import moment from 'moment-timezone';

export const getDateFormat = (date = new Date(), format = 'YYYY-MM-DD', timeZone = 'America/Bogota', ) => {
    return moment.tz(date, timeZone).format(format)
}